<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="发起人"
        ><BusinessLookupSelect v-model="query.requesterUserId" type="users" placeholder="请选择发起人"
      /></el-form-item>
      <el-form-item label="介绍人"
        ><BusinessLookupSelect v-model="query.introducerUserId" type="users" placeholder="请选择介绍人"
      /></el-form-item>
      <el-form-item label="目标用户"
        ><BusinessLookupSelect v-model="query.targetUserId" type="users" placeholder="请选择目标用户"
      /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-160px">
          <el-option
            v-for="(label, value) in statusLabels"
            :key="value"
            :label="label"
            :value="Number(value)"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="requestNo" label="请求号" min-width="150" show-overflow-tooltip />
      <el-table-column label="发起人" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.requesterUserId" /></template></el-table-column>
      <el-table-column label="介绍人" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.introducerUserId" /></template></el-table-column>
      <el-table-column label="目标用户" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.targetUserId" /></template></el-table-column>
      <el-table-column prop="purpose" label="连接目标" min-width="180" show-overflow-tooltip />
      <el-table-column label="状态" width="120">
        <template #default="scope">{{ statusLabels[scope.row.status] || '未知' }}</template>
      </el-table-column>
      <el-table-column prop="expireTime" label="过期时间" width="180" />
      <el-table-column label="操作" width="130">
        <template #default="scope">
          <el-button link type="primary" @click="openDetail(scope.row.id)">详情</el-button>
          <el-button
            v-if="scope.row.status <= 2"
            v-hasPermi="['bosscircle:warm-intro:manage']"
            link
            type="danger"
            @click="closeRecord(scope.row)"
            >关闭</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="detailVisible" title="暖介绍详情" width="760px">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label="请求号">{{ detail.requestNo }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusLabels[detail.status] }}</el-descriptions-item>
      <el-descriptions-item label="发起人">{{ detail.requesterUserId }}</el-descriptions-item>
      <el-descriptions-item label="介绍人">{{ detail.introducerUserId }}</el-descriptions-item>
      <el-descriptions-item label="目标用户">{{ detail.targetUserId }}</el-descriptions-item>
      <el-descriptions-item label="过期时间">{{ detail.expireTime }}</el-descriptions-item>
      <el-descriptions-item label="连接目标" :span="2">{{ detail.purpose }}</el-descriptions-item>
      <el-descriptions-item label="价值说明" :span="2">{{
        detail.valueStatement || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="拒绝/关闭原因" :span="2">{{
        detail.rejectReason || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="好友申请ID">{{
        detail.friendRequestId || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="推进舱ID">{{ detail.dealRoomId || '-' }}</el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>

<script setup lang="ts">
import * as WarmIntroApi from '@/api/business/warmIntro'

defineOptions({ name: 'BossCircleWarmIntro' })
const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const timeRange = ref<string[]>([])
const detailVisible = ref(false)
const detail = ref<any>()
const statusLabels: Record<number, string> = {
  0: '草稿',
  1: '待介绍人确认',
  2: '待目标确认',
  3: '已接受',
  4: '已拒绝',
  5: '已过期',
  6: '已关闭'
}
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  requesterUserId: undefined,
  introducerUserId: undefined,
  targetUserId: undefined,
  status: undefined
})
const params = () => ({ ...query, beginTime: timeRange.value?.[0], endTime: timeRange.value?.[1] })
const load = async () => {
  loading.value = true
  try {
    const data = await WarmIntroApi.getWarmIntroPage(params())
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openDetail = async (id: number) => {
  detail.value = await WarmIntroApi.getWarmIntro(id)
  detailVisible.value = true
}
const closeRecord = async (row: any) => {
  const { value } = await message.prompt('请输入关闭原因', '关闭暖介绍')
  await WarmIntroApi.closeWarmIntro({ id: row.id, version: row.version, reason: value })
  message.success('已关闭')
  await load()
}
onMounted(load)
</script>
